import { render, staticRenderFns } from "./AverageStatisticIcon.vue?vue&type=template&id=558c6b61&"
import script from "./AverageStatisticIcon.vue?vue&type=script&lang=ts&"
export * from "./AverageStatisticIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports